module.exports = __webpack_public_path__ + "static/media/image_placeholder.3863dbbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image_placeholder.jpg
// module id = 337
// module chunks = 0